var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAltIngr = function SvgAltIngr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9293 11.9805C11.5941 12.7514 9.73633 12.0332 9.73633 12.0332C9.73633 12.0332 10.0433 10.0652 11.3784 9.29433C12.7136 8.5235 14.5714 9.24166 14.5714 9.24166C14.5714 9.24166 14.2644 11.2096 12.9293 11.9805Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09333 9.29449C9.42849 10.0654 9.73543 12.0333 9.73543 12.0333C9.73543 12.0333 7.87764 12.7515 6.54249 11.9806C5.20733 11.2098 4.90039 9.2418 4.90039 9.2418C4.90039 9.2418 6.75818 8.52363 8.09333 9.29449Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1538 10.6378L9.73633 12.0335",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31836 10.6378L9.73588 12.0335",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73438 15.3579V12.033",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1184 14.6859C14.0653 18.242 9.54226 19.4748 6.01652 17.4392C3.82873 16.1761 2.53848 13.9513 2.36494 11.5948",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35066 7.31407C5.40379 3.75794 9.92684 2.52516 13.4526 4.56075C15.6596 5.83497 16.9531 8.08748 17.1077 10.4672",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7207 7.21301L3.00856 8.28645L1.93513 5.5743",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7676 14.5414L16.632 13.991L17.1824 16.8554",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAltIngr;